<div [ngClass]="fuseConfig.layout.navbar.primaryBackground">
    <fuzz-navigation layout="horizontal"></fuzz-navigation>
</div>